import { isBrowser } from './detectEnv';

export const composeGoBackUrlParam = () => {
  if (isBrowser()) {
    return '?goBack=' + encodeURIComponent(window.location.pathname + window.location.search);
  }
  return '';
};
